import React from "react";

export default function AdminPageHeader({ icon, title, description, actions }) {
  return (
    <header className="admin-standard-page-header">
      <div className="admin-standard-heading">
        <span className="admin-standard-title-icon" aria-hidden="true">
          <i className={icon} />
        </span>
        <div>
          <span className="admin-standard-eyebrow">Administration</span>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
      </div>
      {actions ? <div className="admin-standard-header-actions">{actions}</div> : null}
    </header>
  );
}
